//LIBRARIES
import React, { Fragment } from 'react';
import { Formik, yupToFormErrors } from 'formik';
import * as Yup from 'yup';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

//COMPONENTS
import UserDetails from './UserFormSection/UserDetails';
import AdminUser from './UserFormSection/AdminUser';
import PreferenceFields from './UserFormSection/PreferenceFields';
import { VerticalFormWrapper } from 'components/ui/VerticalFormWrapper';

//HELPERS
import { getTranslatedString } from 'helpers/i18n';
import { isValidEmail } from 'helpers/Validator';
import DeactivateAndPasswordReset from './UserFormSection/DeactivateAndPasswordReset';

const requiredErrorVerbiage = getTranslatedString('required');
const invalidPhoneVerbiage = getTranslatedString('validationErrors.invalidPhone');
const invalidEmailVerbiage = getTranslatedString('invalidEmail');

const maintenanceValidationSchema = {
  first_name: Yup.string().required(requiredErrorVerbiage),
  last_name: Yup.string().required(requiredErrorVerbiage),
  phone_number: Yup.string()
    .required(requiredErrorVerbiage)
    .test('phone_number', invalidPhoneVerbiage, function (value) {
      if (!value) return false;
      if (value.replace(/\s/g, '') === '+00000000000') return true;
      const parseResult = parsePhoneNumberFromString(value);
      return parseResult && parseResult.isValid();
    }),
  email: Yup.string()
    .required(requiredErrorVerbiage)
    .test('email', invalidEmailVerbiage, function (value) {
      return isValidEmail(value);
    }),
};

const agentValidationSchema = {
  first_name: Yup.string().required(requiredErrorVerbiage),
  last_name: Yup.string().required(requiredErrorVerbiage),
  mobile_number: Yup.string()
    .required(requiredErrorVerbiage)
    .test('mobile_number', invalidPhoneVerbiage, function (value) {
      if (!value) return false;
      if (value.replace(/\s/g, '') === '+00000000000') return true;
      const parseResult = parsePhoneNumberFromString(value);
      return parseResult && parseResult.isValid();
    }),
  email: Yup.string()
    .required(requiredErrorVerbiage)
    .test('email', invalidEmailVerbiage, function (value) {
      return isValidEmail(value);
    }),
  role: Yup.string().required(requiredErrorVerbiage),
  office_number: Yup.string()
    .required(requiredErrorVerbiage)
    .test('office_number', invalidPhoneVerbiage, function (value) {
      if (!value) return false;
      if (value.replace(/\s/g, '') === '+00000000000') return true;
      const parseResult = parsePhoneNumberFromString(value);
      return parseResult && parseResult.isValid();
    }),
  office_number_extension: Yup.string().nullable(),
};

const UserFormDrawer = ({
  onSubmit,
  initialValues,
  formName,
  enableSubmit,
  user,
  toggleConfirmationDialog,
}) => {
  const validateForm = async (values) => {
    let schema = Yup.object().shape(agentValidationSchema);
    if (values.user_type === 'Maintenance') {
      schema = Yup.object().shape(maintenanceValidationSchema);
    }
    enableSubmit();
    return schema.validate(values, { abortEarly: false }).catch((error) => {
      throw yupToFormErrors(error);
    });
  };

  return (
    <Fragment>
      <Formik initialValues={initialValues} onSubmit={onSubmit} validate={validateForm}>
        {({ handleSubmit, ...rest }) => (
          <VerticalFormWrapper id={formName} onSubmit={handleSubmit}>
            <AdminUser formName={formName} {...rest} />
            <UserDetails {...rest} />
            <DeactivateAndPasswordReset
              user={user}
              toggleConfirmationDialog={toggleConfirmationDialog}
            />
            <PreferenceFields {...rest} />
          </VerticalFormWrapper>
        )}
      </Formik>
    </Fragment>
  );
};

export default UserFormDrawer;
